// @flow
import React from 'react';
import { ScrollTo } from 'react-instantsearch/dom';
import { createConnector } from 'react-instantsearch';
import styled from 'styled-components';

import PropertySearchListItem from './PropertySearchListItem';

import Scrollable from '../../components/shared/Scrollable';

const ListContent = styled.div`
    > button {
        position: absolute;
        right: 10px;
        bottom: calc(1em + 2px);
        cursor: pointer;
    }

    .list-content {
        height: calc(100vh - 152px);
        padding-bottom: 70px;
    }

    .simplebar-content {
        overflow-x: hidden;
    }
`;

const StyledResultsTable = styled.div`
    & .no-results {
        padding: 40px 0;
        text-align: center;
    }

    & table {
        width: 100%;
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: left;
    }

    & th {
        font-weight: normal;
        background: #edf1f2;
        border-bottom: 1px solid #d9d9db;
        padding: 15px 20px;
    }
`;

const PropertySearchList = createConnector({
    displayName: 'PropertySearchList',
    getProvidedProps(props, searchState, searchResults) {
        const noResults = searchResults.results
            ? searchResults.results.nbHits === 0
            : false;

        return {
            query: searchState.query,
            hits: searchResults.results ? searchResults.results.hits : [],
            noResults,
        };
    },
})(({ noResults, query, hits }) => {
    if (noResults) {
        return (
            <div className="no-results">
                <p>
                    No results found for the search query <b>"{query}"</b> (and
                    selected filters).
                </p>
                <p>Please try relaxing your search criteria.</p>
            </div>
        );
    }

    return (
        <ListContent>
            <Scrollable additionalClassName="list-content">
                <StyledResultsTable>
                    <ScrollTo>
                        <table>
                            <thead>
                                <tr>
                                    <th>Reference No</th>
                                    <th>Name</th>
                                    <th>Location</th>
                                    <th>Postcode</th>
                                    <th>Rent p/a</th>
                                    <th>Size</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {hits.map((hit, index) => {
                                    return (
                                        <PropertySearchListItem
                                            key={index}
                                            hit={hit}
                                        />
                                    );
                                })}
                            </tbody>
                        </table>
                    </ScrollTo>
                </StyledResultsTable>
            </Scrollable>
        </ListContent>
    );
});

export default PropertySearchList;



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertySearchList.js